export default "__VITE_ASSET__yr0cWoTf__"